import React from 'react';
export function Gallery() {
  const videos = ['https://cdn.magicpatterns.com/uploads/uqdmdwvQNLfSnfPKaeSpF1/instasaved-08-06-2026 (1).mp4', 'https://cdn.magicpatterns.com/uploads/4YQAqZLbuYqXffKhMVCxdy/instasaved-08-06-2026 (2).mp4', 'https://cdn.magicpatterns.com/uploads/oKjwii4nQFFYqKZE8pon7V/instasaved-08-06-2026.mp4'];
  return <section className="w-full py-20 px-4 bg-background border-t border-[#222222]" data-id="element-45">
      <div className="max-w-6xl mx-auto" data-id="element-46">
        <h2 className="font-display text-4xl md:text-5xl font-bold text-center mb-16 uppercase tracking-wide" data-id="element-47">
          Nuestros <span className="text-gold" data-id="element-48">Trabajos</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-49">
          {videos.map((src, index) => <div key={index} className="aspect-[9/16] overflow-hidden rounded-lg border-2 border-[#222222] hover:border-gold transition-colors shadow-lg bg-black" data-id="element-50">
              <video src={src} autoPlay loop muted playsInline className="w-full h-full object-cover opacity-90 hover:opacity-100 transition-opacity" data-id="element-51" />
            </div>)}
        </div>
      </div>
    </section>;
}